import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles/tokens.css';
import './styles/base.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Missing #root element — check index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
